export default __webpack_public_path__ + "static/media/033-megaphone.c1757114.png";